import React, { Component } from 'react';

class ModalProgress extends Component
{
    render()
    {
        return (
            <div key="downloadProgress" className="modal fade" id="downloadProgress" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="text-center">{ this.props.progressAction }</div>
                            {   this.props.progressSituation === "" ?
                                <div className="spinner-border text-primary d-block mx-auto mt-2" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                                :
                                <div className="progress">
                                    <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" id="progressBar" aria-valuenow={this.props.progressBar} aria-valuemin="0" aria-valuemax="100" style={{width: this.props.progressBar+"%"}}></div>
                                </div>
                            }

                            <div className="text-center" >{ this.props.progressSituation }</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalProgress;


// WEBPACK FOOTER //
// ./src/Components/Search/ModalProgress.js